<div class="stacked-snackbar-container">
  <div 
    *ngFor="let notification of notifications" 
    class="snackbar-item" 
    [ngClass]="notification.type"
    [@slideIn]
    (click)="removeNotification(notification.id)"
  >
    <div class="snackbar-content">{{ notification.message }}</div>
    <button class="close-button" (click)="removeNotification(notification.id)">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>
  </div>
</div> 